import { Heading } from 'roo-ui/components';

const ContentHeading = (props) => <Heading.h3 mb={[4, 5]} fontSize={['xl', '2xl']} {...props} />;

ContentHeading.displayName = 'ContentHeading';

export default ContentHeading;
